import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import ContainerlessTableViewApp from '../../TableView/startup/ContainerlessTableViewApp';
import NameCell from './cells/NameCell';
import StatusBadge from '../../../shared/StatusBadge';
import PriceIntervalCell from './cells/PriceIntervalCell';
import ProductLinkCell from './cells/ProductLinkCell';

const ALL_COLUMNS = [
  { data: 'name', label: 'Name' },
  { data: 'status', label: 'Status' },
  { data: 'price_and_interval', label: 'Price' },
  { data: 'current_period_end', label: 'Renewal' },
  { data: 'membership_product', label: 'Membership' },
];

export default function MembershipsDatatable({
  datatablePath,
  membershipProductId = null,
  showProductColumn = false,
  filters = null,
}) {
  const columns = useMemo(() => (
    showProductColumn ? ALL_COLUMNS : ALL_COLUMNS.filter((column) => column.data !== 'membership_product')
  ), [showProductColumn]);

  // When the parent scopes to a product via membershipProductId, bake the
  // filter into the datasource URL so it's always sent (even without a
  // FilterPanel). The Members tab uses the `filters` prop + FilterPanel
  // instead, matching the ahoy_messages pattern.
  const dataSource = useMemo(() => {
    if (!membershipProductId) return datatablePath;
    const separator = datatablePath.includes('?') ? '&' : '?';
    return `${datatablePath}${separator}membership_product_id=${encodeURIComponent(membershipProductId)}`;
  }, [datatablePath, membershipProductId]);

  const rowCallback = useMemo(() => (row, rowData) => {
    const nameElement = row.getElementsByClassName('name-cell')[0];
    if (nameElement) {
      ReactDOM.render(
        <NameCell
          firstName={rowData.first_name}
          lastName={rowData.last_name}
          email={rowData.email}
          path={rowData.membership_show_path}
        />,
        nameElement,
      );
    }

    const statusElement = row.getElementsByClassName('status-cell')[0];
    if (statusElement) {
      ReactDOM.render(
        <StatusBadge status={rowData.status_value} />,
        statusElement,
      );
    }

    const priceElement = row.getElementsByClassName('price-cell')[0];
    if (priceElement) {
      ReactDOM.render(
        <PriceIntervalCell
          amountCents={rowData.amount_cents}
          interval={rowData.interval}
        />,
        priceElement,
      );
    }

    if (showProductColumn) {
      const productElement = row.getElementsByClassName('product-cell')[0];
      if (productElement) {
        ReactDOM.render(
          <ProductLinkCell
            name={rowData.membership_product_name}
            path={rowData.membership_product_path}
          />,
          productElement,
        );
      }
    }
  }, [showProductColumn]);

  return (
    <div>
      <ContainerlessTableViewApp
        key={`members-${membershipProductId || 'all'}`}
        dataSource={dataSource}
        columns={columns}
        filters={filters || []}
        rowCallback={rowCallback}
      />
    </div>
  );
}
